import React, { ReactNode, useEffect, useState } from 'react';
import { RouteProps } from 'react-router-dom';
import { Role } from '../../constants/roles';
import { getRoles } from '../../services/role-service';
import Error401 from 'views/Error401';

export enum MatchLogic {
  AND = 'AND',
  OR = 'OR'
}

export type ProtectedRouteProps = RouteProps & {
  requiredRoles: Role[];
  matchLogic: MatchLogic;
  children: ReactNode;
};

const ProtectedRoute = ({ requiredRoles, matchLogic, children }: ProtectedRouteProps) => {
  const [canShowChildElements, setCanShowChildElements] = useState(false);
  const [hasFinishedLoading, setHasFinishedLoading] = useState(false);

  useEffect(() => {
    if (requiredRoles.length === 0) {
      setCanShowChildElements(true);
      setHasFinishedLoading(true);
    } else if (matchLogic === MatchLogic.OR) {
      getRoles().then(roles => {
        setCanShowChildElements(
          requiredRoles.map(a => roles.includes(a)).some(Boolean)
        );
        setHasFinishedLoading(true);
      });
    } else if (matchLogic === MatchLogic.AND) {
      getRoles().then(roles => {
        setCanShowChildElements(
          requiredRoles.map(a => roles.includes(a)).every(Boolean)
        );
        setHasFinishedLoading(true);
      });
    } else {
      setCanShowChildElements(false);
      setHasFinishedLoading(true);
    }
  }, [requiredRoles, matchLogic]);

  if (canShowChildElements) {
    return <>{children}</>;
  }
  return hasFinishedLoading ? <Error401 /> : <></>;
}

export default ProtectedRoute;
